// packages/ws-bridge/src/types.ts
export type WSNamespace = "WS_BRIDGE";
export type ORGNamespace = "ORG_BRIDGE";
export type WSFrom = "workspace" | "app" | "admin" | "organization";

// Version constants
export const ALLOWED_BRIDGE_VERSIONS = ["1.0", "2.0"] as const;
export type AllowedBridgeVersion = (typeof ALLOWED_BRIDGE_VERSIONS)[number]; // "1.0" | "2.0"

export const BRIDGE_VERSION: AllowedBridgeVersion = "2.0";
export type BridgeVersion = AllowedBridgeVersion;

export enum ParentType {
  WORKSPACE = "workspace",
  ORGANIZATION = "organization",
}

export enum WSEventType {
  // Workspace → App events
  WS_HELLO = "WS_HELLO",
  WS_CONTEXT_UPDATE = "WS_CONTEXT_UPDATE",
  WS_LANGUAGE_CHANGED = "WS_LANGUAGE_CHANGED",
  WS_WORKSPACE_CHANGED = "WS_WORKSPACE_CHANGED",
  WS_ORG_CHANGED = "WS_ORG_CHANGED",
  WS_SESSION_EXPIRED = "WS_SESSION_EXPIRED",
  WS_APP_NAVIGATE = "WS_APP_NAVIGATE",
  WS_CUSTOM_EVENT = "WS_CUSTOM_EVENT",

  // Organization → App events
  ORG_HELLO = "ORG_HELLO",
  ORG_CONTEXT_UPDATE = "ORG_CONTEXT_UPDATE",
  ORG_LANGUAGE_CHANGED = "ORG_LANGUAGE_CHANGED",
  ORG_WORKSPACE_CHANGED = "ORG_WORKSPACE_CHANGED",
  ORG_SESSION_EXPIRED = "ORG_SESSION_EXPIRED",
  ORG_APP_NAVIGATE = "ORG_APP_NAVIGATE",
  ORG_CUSTOM_EVENT = "ORG_CUSTOM_EVENT",

  // App → Parent events
  APP_HELLO = "APP_HELLO",
  APP_READY = "APP_READY",
  APP_CONTEXT_REQUEST = "APP_CONTEXT_REQUEST",
  APP_SHOW_TOAST = "APP_SHOW_TOAST",
  APP_NAVIGATE = "APP_NAVIGATE",
  APP_LOGOUT_REQUEST = "APP_LOGOUT_REQUEST",
  APP_GO_TO_ADMIN = "APP_GO_TO_ADMIN",
  APP_GO_TO_ORG = "APP_GO_TO_ORG",
  APP_CUSTOM_EVENT = "APP_CUSTOM_EVENT",
}

export interface WSMessage<T = any> {
  namespace: WSNamespace | ORGNamespace;
  from: WSFrom;
  app_id?: number;
  type: WSEventType | string;
  version: BridgeVersion;
  request_id?: string;
  payload?: T;
}

export interface WSContext {
  workspace_id?: string;
  workspace_name?: string;
  org_id?: string;
  org_name?: string;
  org_domain?: string;
  user_id?: string;
  user_email?: string;
  user_name?: string;
  locale?: string;
  roles?: string[];
  timezone?: string;
  permissions?: string[];
}

export interface WSHelloPayload extends WSContext {}
export interface AppHelloPayload {
  app_id?: number;
  app_version?: string;
  app_name?: string;
  user_id?: string; // User ID from token for validation
  workspace_id?: string; // Workspace ID from token for validation
  org_id?: string; // Organization ID from token for validation
}
export interface AppReadyPayload {
  workspace_id?: string;
  initial_route?: string;
  metadata?: Record<string, any>;
}

export interface AppShowToastPayload {
  level: "info" | "success" | "warning" | "error";
  message: string;
  duration_ms?: number;
}

export interface AppNavigatePayload {
  target: "app" | "admin" | "workspace" | "organization";
  app_id?: number;
  route?: string;
  params?: Record<string, any>;
  new_tab?: boolean;
}

export interface CustomEventPayload {
  workspace_id?: string;
  event_name: string;
  data?: any;
}

export interface OrgChangedPayload {
  org_id: string;
  org_name?: string;
  workspace_id?: string;
  workspace_name?: string;
}
